import { AxiosRequestConfig, Method } from 'axios';
import { MutableRefObject, useMemo, useRef } from 'react';
import cookie from 'react-cookies';
import {
  Loadable,
  selectorFamily,
  SerializableParam,
  SetterOrUpdater,
  useRecoilValueLoadable,
  useSetRecoilState,
} from 'recoil';
import axios from '../../common/axiosInterceptor';
import { Logger } from '../../common/Logger';
import { IUserAtom, user } from '../../recoil/atoms/user';
import { refetchToggle } from '../../recoil/selectors/makePHPRequest';
import { makeAPIPayload } from './makeAPIPayload';

export enum endpointEnum {
  ADD_AGENT_TEAM = 'legacy/addAgentsTeam',
  ADD_NEW_CADENCE = 'v1/cadences',
  ADD_NEW_POWERLIST = 'v1/upsertPowerlist',
  CLONE_POWERLIST = 'v1/clonePowerlist',
  ADD_NEW_DISPOSIITON = 'legacy/submitNewDisposition',
  ADD_PORT = 'legacy/submitPortPrep',
  ADD_SPAM_LIKELY = 'legacy/manualAddSpamLikely',
  ADD_TEAM_QUEUE = 'legacy/addTeamQueue',
  CADENCE_ACTION_PROCESS = 'v1/cadenceActionProcesses',
  CHECK_APP_UPDATE = 'v1/checkAppUpdate',
  CHECK_EMAIL_AVAILABILITY = 'checkEmailAvailability',
  CLOSE_DEAL_BY_BUSINESS_ID = 'legacy/closeDealByBusinessId',
  CLOUDWATCH_LOGGER = 'cloudwatchLogger',
  DELETE_CADENCE = 'v1/cadences',
  DELETE_CONFERENCE = 'legacy/deleteConference',
  DELETE_DEVICE = 'legacy/deleteDevice',
  DELETE_DISPOSITION = 'legacy/deleteDisposition',
  DELETE_GROUP = 'legacy/deleteGroup',
  DELETE_IVR = 'legacy/deleteIvr',
  DELETE_NUMBER = 'legacy/deleteNumber',
  DELETE_QUEUE = 'legacy/deleteQueue',
  DELETE_QUEUE_TEAM = 'legacy/deleteQueueTeam',
  DELETE_SMS_TEMPLATE = 'legacy/deleteSMSt',
  DELETE_TEAM = 'legacy/deleteTeam',
  DELETE_TEAM_MEMBER = 'legacy/deleteTeamMember',
  DELETE_VM_DROP = 'legacy/deleteVmd',
  DELETE_WEBHOOK = 'legacy/deleteWebhook',
  EDIT_CONFERENCE = 'legacy/editConference',
  EDIT_DISPOSITION = 'legacy/editDisposition',
  EDIT_NUMBER = 'legacy/editNumber',
  EDIT_NUMBER2 = 'legacy/editNumber2',
  FLUSH_USER_QUEUE = 'legacy/flushUserQueue',
  FORWARDER = 'v1/forwarder', // eslint-disable-line no-unused-vars
  GET_BUSINESSES = 'v1/businesses',
  GET_BUSINESS_CONFERENCES = 'legacy/getBusinessConferences',
  GET_BUSINESS_DATA = 'legacy/getbusinessdata',
  GET_HAS_USERS_OAUTHED = 'legacy/getHasBusinessUserOauthed',
  GET_BUSINESS_DEVICES = 'legacy/getBusinessDevices',
  GET_USER_DEVICES = 'legacy/getDevicesByUseridCheckEndpoint',
  GET_POWERLIST_DISPOSITION_RULES = 'legacy/getPowerlistDispositionRules',
  UPDATE_USER_DEVICE = 'legacy/updateUserSipEndpoint',
  GET_BUSINESS_CRM_STATS = 'legacy/getBusinessCRMStats',
  GET_BUSINESS_DIDS = 'legacy/getBusinessDIDs',
  GET_BUSINESS_GROUPS = 'legacy/getBusinessGroups',
  GET_BUSINESS_NUMBERS = 'legacy/getBusinessNumbers',
  GET_BUSINESS_NUMBER_REPORTING = 'getbusinessnumberreporting',
  GET_BUSINESS_PRODUCTS = 'legacy/getBusinessProducts',
  GET_BUSINESS_TEAMS = 'legacy/getBusinessTeams',
  GET_BUSINESS_USERS = 'legacy/getBusinessUsers',
  GET_CADENCE = 'v1/cadences',
  GET_CADENCE_REPORT = 'v1/cadences/report',
  GET_BUSINESS_POWERLISTS = 'v1/getBusinessPowerlists',
  GET_NUMBER_SPAM_LIKELY_SCORE = 'legacy/getNumberSpamLikelyScore',
  GET_USER_TEAM_POWERLISTS = 'powerlistsAll',
  GET_USER_POWERLISTS = 'v1/getUserPowerlists',
  GET_POWERLIST_SPREADSHEET_URL = 'v1/getSignedURLSpreadsheet',
  GET_TRANSFER_ATTEMPTS = 'legacy/getTransferAttemptsByBusinessId',
  BUSINESS_SMS = 'businessSMS/teamSMS',
  BUSINESS_SMS_NUMBERS = 'businessSMS/getBusinessSMSNumbers',
  BUSINESS_SMS_BY_BUSINESS = 'businessSMS/teamSMS',
  DELETE_POWERLIST = 'v1/deletePowerlist',
  DELETE_POWERLIST_CONTACT = 'v1/deletePowerlistContact',
  TOGGLE_POWERLIST_STATUS = 'v1/togglePowerlistStatus',
  GET_CUSTOM_CRM = 'legacy/getCustomCRM',
  GET_POWERLIST = 'v1/getPowerlist',
  GET_POWERLIST_CONTACTS = 'v1/getPowerlistContacts',
  GET_POWERLIST_CONTACTS_SUMMARY = 'v1/getPowerlistContactsSummary',
  GET_QUEUE_TEAMS = 'legacy/getQueueTeams',
  GET_QUEUES_LIVE_REPORTING = 'legacy/getIncomingLiveQueueReportsByBusinessid',
  GET_SMS_TEMPLATE = 'legacy/getAllsmstemplate',
  GET_TEAM_SETTINGS = 'legacy/getTeamSettings',
  GET_THREADED_SMS = 'getthreadedsms',
  GET_TOKEN = 'getToken',
  GET_VM_DROP = 'legacy/getvmdrop',
  GET_WEBHOOKS = 'legacy/getWebhooks',
  GET_CALL_METRICS = 'callMetrics',
  OTHERS_CAN_VIEW_RECORDINGS = 'legacy/updateOthersCanViewRecordings',
  PATCH_BUSINESSES = 'v1/businesses',
  PATCH_CADENCE = 'v1/cadences',
  POST_WEBHOOK = 'legacy/postWebhook',
  PUT_CUSTOM_CRM = 'legacy/putCustomCRM',
  PUT_WEBHOOK = 'legacy/putWebhook',
  SEARCH_BUSINESS = 'legacy/searchBusiness',
  GET_QUEUE_MEMBERS = 'legacy/getQueueMembers',
  SEND_SMS = 'sendsms',
  SMS_REPORTS = 'getbusinessuserSMSreporting',
  SUBMIT_NEW_CONFERENCE = 'legacy/submitnewconference',
  SUBMIT_NEW_DEVICE = 'legacy/submitNewDevice',
  SUBMIT_NEW_IVR = 'legacy/submitnewivr',
  SUBMIT_NEW_QUEUE = 'legacy/submitnewqueue',
  SUBMIT_NEW_TEAM = 'legacy/submitnewteam',
  SUBMIT_NEW_TEMPLATE = 'legacy/submitNewSMSTemplate',
  SYNC_CONTACTS = 'syncContacts',
  UPDATE_DISPOSITIONS_HUBSPOT = 'hubspot/getCallDispositionsHubspot',
  UPDATE_BUSINESS = 'legacy/updateBusiness',
  UPDATE_BUSINESS_SETTINGS = 'legacy/updateBusinessSettings',
  UPDATE_DEFAULT_DEVICE = 'legacy/updateDefaultDevice',
  UPDATE_IVR_EXTENSION_DIALING = 'legacy/updateIVR',
  UPSERT_BUSINESS_DISPOSITION_RULES = 'legacy/upsertBusinessPowerlistDispositionRules',
  SUBMIT_CANCELLATION_SURVEY = 'legacy/submitCancellationSurvey',
  UPDATE_LOCAL_PRESENCE = 'legacy/updateLPlite',
  UPDATE_LOCAL_PRESENCE_SETTING = 'legacy/updateLocalPresenceSetting',
  UPDATE_POWERLIST_PRODUCT = 'legacy/updatePowerlistProduct',
  UPDATE_SUPERADMIN_SETTINGS = 'legacy/updateSuperadminSettings',
  CALL_TRANSCRIPTION_PRODUCT = 'userProducts/{businessId}/{userId}/callTranscription',
  UPDATE_QUEUE = 'legacy/updateQueue',
  UPDATE_RECHARGE = 'legacy/updateRecharge',
  UPDATE_SMS_TEMPLATE = 'legacy/updateSMSTemplate',
  UPDATE_TEAM_NAME = 'legacy/updateTeam',
  UPDATE_USER = 'legacy/updateUser',
  UPDATE_USER_2 = 'legacy/updateUser2',
  UPDATE_VM_DROP_NAME = 'legacy/updateVMDropName',
  DELETE_SCHEDULED_CADENCE = 'v1/cadences/cadenceScheduledActions',
  BUY_CONNECTION_BOOST_START = 'v1/buyConnectionBoostStart',
  TRANCHE_ACTION_HANDLER = 'tranche',
  GET_BUSINESS_ROUTING_RULES = 'legacy/getRoutingRulesByBusinessId',
  GET_ROUTING_RULE = 'legacy/getRoutingRuleById',
  DELETE_ROUTING_RULE = 'legacy/deleteRoutingRule',
  UPSERT_ROUTING_RULE = 'legacy/upsertRoutingRule',
  UPDATE_ROUTING_RULES_ORDER = 'legacy/updateRoutingRulesOrder',
  UPDATE_ROUTING_RULE_ACTIVE = 'legacy/updateRoutingRulesActive',
  UPDATE_BUSINESS_2 = 'legacy/updateBusiness2',
  UPDATE_BUSINESS_3 = 'legacy/updateBusiness3',
  UPDATE_BUSINESS_4 = 'legacy/updateBusiness4',
  GET_BUSINESS_SMS_BY_BUSINESS = 'legacy/getBusinessSMSByBusinessId',
  GET_10DLC_PROFILE_BRAND = 'legacy/get10DlcProfileBrand',
  UPDATE_10DLC_PROFILE = 'legacy/10DlcProfileUpdate',
  GET_10DLC_CAMPAIGNS = 'legacy/get10DlcCampaigns',
  GET_10DLC_STATUS_MESSAGE = 'legacy/get10DlcStatusMessage',
  GET_USAGE_PLANS = 'legacy/getUsagePlans',
  GET_CALL_REVIEW = 'callReview',
  GET_AGENT_STATS = 'businesses/{businessId}/agents/{userId}/stats',
  GET_BUSINESS_STATS = 'businessStats/{businessId}',
  MAKE_PHONE_CALL = 'makeUnloggedPhoneCalls',
  GET_SUPER_ADMIN_BUSINESS_STATS = 'superAdminBusinessStats',
  GET_LEADERBOARDS = 'getLeaderboards',
  DELETE_LEADERBOARD = 'deleteLeaderboard',
  UPSERT_LEADERBOARD = 'upsertLeaderboard',
  GET_NOTES_BY_BUSINESS = 'legacy/getNotesByBusiness',
  UPSERT_NOTE = 'legacy/upsertNote',
  UPDATE_NOTE_DISPLAY_ORDER = 'legacy/updateNoteDisplayOrder',
  ARCHIVE_NOTE = 'legacy/archiveNote',
  GET_NOTE_HISTORY = 'legacy/getNoteHistory',
  PROXY_HUBSPOT_VISITOR_IDENTIFICATION_API = 'legacy/proxyHubspotVisitorIdentificationAPI',
  UPDATE_OW_ACCOUNT_SETTINGS = 'onboardingWalkthrough/account',
  UPDATE_OW_WIZARD = 'onboardingWalkthrough/wizard',
  UPDATE_OW_DISPLAY = 'onboardingWalkthrough/displayOnboarding',
  COMPLETE_OW = 'onboardingWalkthrough',
  GET_OW_STATUS = 'onboardingWalkthrough/status',
  GET_OW = 'onboardingWalkthrough',
  BUSINESS_CRM = 'businessCRM',
  GET_API_USAGE = 'legacy/getUsageReport',
  GET_USAGE_REPORTS_BY_BUSINESSID = 'legacy/getUsageReportByBusinessId',
  GET_BUSINESS_USER_REPORTING = 'getbusinessuserreporting2',
  GET_BLOCKED_NUMBERS = 'blockedNumbers/numbers',
  GET_BUSINESS_USER_TIME_SAVED_REPORTING = 'getbusinessusertimesavedreporting',
  GET_USER_PRODUCTS = 'products/{businessId}/{userId}',
  CALL_TRANSCRIPTION_SETTINGS = 'transcriptions/settings/{businessId}',
  GET_SCHEDULED_REPORTS = 'scheduledReports/{bid}',
  GET_SCHEDULED_REPORT = 'scheduledReports/{bid}/{scheduledReportId}',
  ADD_SCHEDULED_REPORT = 'scheduledReports/{bid}/',
  UPDATE_SCHEDULED_REPORT = 'scheduledReports/{bid}/{scheduledReportId}',
  DELETE_SCHEDULED_REPORT = 'scheduledReports/{bid}/{deleteID}',
  EMAIL_REPORTS = 'emailReports/{bid}',
  GET_VOICEMAILS = 'getuservoicemail',
  GET_CALL_TRANSCRIPTION = 'transcriptions/calls/{businessId}/{callXd}',
  RESEND_SCHEDULED_REPORT = 'resendReports/{bid}',
  GET_JIRA_REPORTS = 'jira-integration',
  GET_VM_TRANSCRIPTION = 'transcriptions/voicemails/{businessId}/{callXd}',
  USER_SETTINGS_UPDATED = 'userSettingsUpdated/{businessId}/{userId}',
  GET_AGENT_STATUS_METRICS = 'agentStatusMetrics',
  GET_BUSINESS_SEGMENT = 'legacy/getBusinessSegment',
  GET_BUSINESS_SEGMENT_ES_DATA = 'legacy/getBusinessSegmentESData',
  GET_HELP_DESK_ARTICLES = 'legacy/getHelpDeskArticles',
  SEARCH_HELP_DESK_ARTICLES = 'legacy/searchHelpDeskArticles',
  GET_POWERLIST_CONTACT_DATA_SOURCES = 'powerlistContacts/GetContactDataSources',
  GET_POWERLIST_CONTACT_LISTS = 'powerlistContacts/GetContactLists/{crmid}',
  GET_POWERLIST_CONTACT_PROPERTIES = 'powerlistContacts/GetContactProperties/{crmid}',
  GET_AUDIT_EVENTS = 'legacy/getAuditEvents',
  ADD_EXTERNAL_DIRECTORY = 'legacy/insertExternalDirectory',
  GET_POWERLIST_DIAL_ATTEMPTS = 'legacy/getPowerlistDialAttemptsByBusiness',
  REFUND_STRIPE_CHARGE_BY_CHARGE_ID = 'legacy/refundStripeChargeByChargeId',
}

export interface IMakeAPIRequest
  extends Readonly<{ [key: string]: SerializableParam }> {
  /** endpoint of API (eg. getnumberbusinessreport) */
  endpoint: string;
  /** payload for API request (must be a json string since it needs to be serializable) */
  payloadJsonString?: string;
  /** do not perform request until makeAPIPayload atom is fulfilled */
  waitForPayload?: boolean;
  /** Transaction id to break selector cache */
  transactionId?: string;
  /** HTTP method for request */
  method?: Method;
  /** Override default content-type */
  contentType?: string;
  /** Value used for triggering refetch when endpoint isn't specific enough */
  refetchParam?: SerializableParam;
}

// export interface IMakeAPIResponse {
//   response?: AxiosResponse | undefined;
//   exception?: AxiosError | Error | Response;
// }

/**
 * Selector used to call API
 * NOTE: can return with null if user storage data has not been set
 *
 * @returns Axios response
 *
 * @example
 *  const getBusinessNumbersReportingLoadable = useRecoilValueLoadable(
 *    makeAPIRequest({
 *      endpoint: endpointEnum.GET_BUSINESS_NUMBER_REPORTING,
 *      // payloadJsonString: JSON.stringify({
 *      //   call: methodNameEnum.GET_BUSINESS_NUMBERS_REPORTING,
 *      //   startdate: '2020-10-03T23:39:38.671Z',
 *      //   enddate: '2020-11-03T00:39:38.671Z',
 *      //   timezone: 'America/Los_Angeles',
 *      // }),
 *      waitForPayload: true,
 *    })
 *  );
 *  const getBusinessNumbersReporting = getBusinessNumbersReportingLoadable.contents as IMakeAPIResponse;
 *
 *  const setPayload = useSetRecoilState<any>(
 *    makeAPIPayload(endpointEnum.GET_BUSINESS_NUMBER_REPORTING)
 *  );
 *
 *  console.log(getBusinessNumbersReporting?.response);
 */
export const makeAPIRequest = selectorFamily<any | undefined, IMakeAPIRequest>({
  key: 'makeAPIRequest',
  get: ({
    endpoint,
    payloadJsonString = '{}',
    waitForPayload = false,
    transactionId = '', // use this to break cache
    method = 'post',
    contentType = 'application/x-www-form-urlencoded;charset=utf-8',
    domain,
    stage,
    refetchParam,
  }: IMakeAPIRequest) => async ({
    get, // add any to allow usage of recoil without the need to specify type
  }): Promise<any | undefined> => {
    const userAtom = get<IUserAtom | Record<string, unknown>>(
      user
    ) as IUserAtom;
    // subscribe so refresh-toggle
    get(refetchToggle(refetchParam ?? endpoint));
    const accessToken = cookie.load('accessToken') || userAtom.accessToken; // use old access token
    let payload;
    // conditionally subscribe
    if (waitForPayload) {
      payload = get<any>(makeAPIPayload(endpoint));
    }
    // return undefined if user storage data is not set
    // or if not ready
    if ((waitForPayload && !payload) || !Object.keys(userAtom).length) {
      Logger.trace(
        {
          pathname: window.location.pathname,
          businessid: userAtom.businessid,
          apiKey: userAtom.apikey,
          userid: userAtom.user?.userid,
          endpoint,
          message: 'Ajax not executed - payload empty or userAtom empty',
          waitForPayload,
          payload,
          userAtom: Object.keys(userAtom).length,
        },
        'makeAPIRequest'
      );
      return;
    }

    let request: AxiosRequestConfig;
    const url = `${(domain as string) ?? process.env.VITE_APP_API_DOMAIN}/${
      (stage as string) ?? process.env.VITE_APP_API_STAGE
    }/${endpoint}`;

    // if payload is file then post using FormData
    if (payload?.file) {
      const data = new FormData();
      data.append('businessid', String(userAtom.businessid));
      data.append('apiKey', userAtom.apikey as string);
      data.append(payload.file.name, payload.file.content);
      Object.entries(payload?.payload ?? {}).forEach(
        ([key, value]: [string, any]) => {
          data.append(key, value);
        }
      );

      // if no payload then put body in query param for readability on network trace
      request = {
        method,
        url,
        headers: {
          'content-type': 'multipart/form-data',
        },
        data,
      };
    } else {
      // otherwise post as normal
      request = {
        method,
        url,
        data: {
          businessId: userAtom.businessid,
          businessid: userAtom.businessid,
          apiKey: userAtom.apikey,
          apikey: userAtom.apikey,
          ...JSON.parse(payloadJsonString),
          ...payload,
        },
        headers: {
          Authorization: accessToken, // accessToken in recoil maybe stale
          'x-api-key': userAtom.apikey,
          'Content-Type': contentType,
        },
      };
    }

    try {
      // validate user is populated first
      const response = await axios(request);
      Logger.info(
        {
          pathname: window.location.pathname,
          businessid: userAtom.businessid,
          apiKey: userAtom.apikey,
          userid: userAtom.user?.userid,
          endpoint,
          request,
          // response,
        },
        'makeAPIRequest'
      );
      // create new response for every request in order to
      // have useEffect dependency triggers work correctly
      return { response };
    } catch (exception) {
      Logger.error(
        {
          pathname: window.location.pathname,
          businessid: userAtom.businessid,
          apiKey: userAtom.apikey,
          userid: userAtom.user?.userid,
          endpoint,
          request,
          exception,
        },
        'makeAPIRequest'
      );
      return { exception };
    }
  },
});

/**
 * Call makeAPIRequest selector and return cached values as React ref, loadable selector result and callable refetcher
 *
 * @param request Request to MakeApiRequest
 * @param getContent Function to retieve value from loadable
 * @param initialValue Value that cache has before fetching data
 * @param dependencies array of objects used to determine when to update cache
 *
 * @returns [ref-cached-value, loadable, refetch-toggle]
 *
 * @example
 *  const [businessDataCached, businessDataLoadable] = makeApiRequestCached<IBusinessModel | undefined> (
 *    {
 *      endpoint: endpointEnum.GET_BUSINESS_DATA,
 *      payloadJsonString: JSON.stringify({
 *        call: methodNameEnum.GET_BUSINESS_DATA,
 *      }),
 *    },
 *    (loadable, cached) =>
 *      loadable.contents?.response?.data?.result?.[0] ?? cached.current
 *  );
 */
export function makeApiRequestCached<T = any>(
  request: IMakeAPIRequest,
  getContent: (loadable: Loadable<any>, cached: MutableRefObject<T>) => any,
  initialValue?: T,
  dependencies: any[] = []
): [MutableRefObject<T>, Loadable<any>, SetterOrUpdater<any>] {
  const loadable = useRecoilValueLoadable(makeAPIRequest(request));
  const cached = useRef<T>(initialValue as T);
  cached.current = useMemo(() => getContent(loadable, cached), [
    loadable,
    ...dependencies,
  ]);
  const setRefetchToggle = useSetRecoilState(
    refetchToggle(request.refetchParam ?? request.endpoint)
  );

  return [cached, loadable, setRefetchToggle];
}
